export default __webpack_public_path__ + "static/media/DefaultAvatar.6fdc8889.jpg";